<template>
  <div class="mobile-card-full new">
    <div class="mobile-card-list">
      <div class="block-header" style="width: 100%;">
        <h4>{{ name }}</h4>
        <a :href="link" class="block-header-about">
          Все статьи
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.9467 7.74671C11.9149 7.66488 11.8674 7.59011 11.8067 7.52671L8.47333 4.19338C8.41117 4.13122 8.33738 4.08191 8.25617 4.04827C8.17495 4.01463 8.08791 3.99731 8 3.99731C7.82246 3.99731 7.6522 4.06784 7.52667 4.19338C7.46451 4.25553 7.4152 4.32933 7.38156 4.41054C7.34792 4.49176 7.33061 4.5788 7.33061 4.66671C7.33061 4.84424 7.40113 5.01451 7.52667 5.14004L9.72667 7.33338H4.66667C4.48986 7.33338 4.32029 7.40361 4.19526 7.52864C4.07024 7.65366 4 7.82323 4 8.00004C4 8.17685 4.07024 8.34642 4.19526 8.47145C4.32029 8.59647 4.48986 8.66671 4.66667 8.66671H9.72667L7.52667 10.86C7.46418 10.922 7.41458 10.9958 7.38074 11.077C7.34689 11.1582 7.32947 11.2454 7.32947 11.3334C7.32947 11.4214 7.34689 11.5085 7.38074 11.5898C7.41458 11.671 7.46418 11.7447 7.52667 11.8067C7.58864 11.8692 7.66238 11.9188 7.74361 11.9526C7.82485 11.9865 7.91199 12.0039 8 12.0039C8.08801 12.0039 8.17514 11.9865 8.25638 11.9526C8.33762 11.9188 8.41136 11.8692 8.47333 11.8067L11.8067 8.47338C11.8674 8.40997 11.9149 8.33521 11.9467 8.25338C12.0133 8.09107 12.0133 7.90902 11.9467 7.74671Z"
              fill="#6F6F6F" />
          </svg>
        </a>
      </div>
      <hr class="line" />

      <div class="cards-list">
        <div v-for="article in items.slice(0, -1)" :key="'__article-' + code + '-' + article.id">
          <a :href="article.url" class="card-article">
            <div class="content">
              <p class="title" v-html="article.original_name"></p>
              <p class="description">{{ article.description }}</p> <!-- .split(' ').slice(0, 10).join(' ') + '...' -->
            </div>
            <img :src="article.image">
          </a>
          <hr class="line" />
        </div>
      </div>
    </div>
    <ArticleCardMobile :article="items[3]" />
  </div>
</template>
<script>
import ArticleCardMobile from '@/components/newRedesign/UI/ArticleCardMobile'

export default {
  props: {
    name: String,
    items: Array,
    link: String,
    code: String,
  },
  data: () => {
    return {

    }
  },
  components: {
    ArticleCardMobile
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.new-journal .mobile-card-full.new {
  padding-top: 29px;
  margin: 0;
  width: 315px;

  .mobile-card-list {
    margin-left: 13px;

    .block-header {
      h4 {
        font-size: 16px;
        line-height: 19px;
        padding: 0;
        padding-bottom: 9px;
      }

      .block-header-about {
        padding-right: 0;
      }
    }

    .line {
      width: 100vw;
      margin-left: calc((100vw - 289px) / -2);
      margin-top: 0;
    }
  }

}

.cards-list {
  .card-article {
    display: flex;
    align-items: center;
    padding: 9px 0 11px;

    .content {
      width: 268px;
      color: #333333;
      padding-right: 2px;

      .title {
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        padding-bottom: 5px;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
      }
    }

    img {
      width: 32px;
      height: 32px;
      border-radius: 64px;
    }
  }
}
</style>